import styled from 'styled-components';

export const RnRRatingRange = styled.section`
  background: white;
  padding: 1.5rem;
`;
export const ProgressWrap = styled.aside`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 1rem;
`;
export const RatingLevel = styled.span`
  font-size: 1rem;
  color: #777;
  padding-right: 0.5rem;
`;
export const ProgressBar = styled.div`
  max-width: 22.5rem;
  width: 100%;
  height: 0.2rem;
  border-radius: 1rem;
  background: #e1e1e1;
  position: relative;
  overflow: hidden;
`;
export const ProgressActiveBar = styled.div`
  background: #2276e3;
  position: absolute;
  left: 0;
  height: 0.2rem;
  width: ${props => props.width};
`;
export const RatingPercentage = styled.span`
  font-size: 1.2rem;
  color: #777;
  padding-left: 1rem;
`;
export const RatingHeader = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 1.5rem;
`;
export const RatingNumber = styled.span`
  font-size: 1.8rem;
  color: #18a160;
  font-weight: bold;
  padding-right: 0.5rem;
`;
export const TotalReviews = styled.span`
  font-size: 1.4rem;
  color: #777;
  padding-left: 1rem;
`;
